export const routeVersion = "2";

export const galleryDefault = {
	open:	false,
	index:	0,
};

export const destinationState = {
	destinationGallery:	galleryDefault,
	hotelGallery:		galleryDefault,
	sightsOpen:			false,
	wishOpen:			true,
	wishTmp:			"",
};
